import React from "react";
import { EventSelectWrapper } from "./styled/styled";
import RxLogo from "../../assets/RxLogo.png";
import { ComponentWithChildren } from "../../common/types";

const SettingsSelectPage: ComponentWithChildren = ({ children }) => {
  return (
    <EventSelectWrapper>
      <img src={RxLogo} alt={"rx-global-logo"} />
      <div>{children}</div>
    </EventSelectWrapper>
  );
};

export default SettingsSelectPage;
